import React from 'react';
import PropTypes from 'prop-types';
import AppBreadcrumbs from 'components/AppBreadcrumbs';
import PageLayout from 'layouts/PageLayout';
import { makeStyles } from '@material-ui/core/styles';
import { useAsyncFn } from 'react-use';
import { createJobTask } from 'http/jobsTasks';
import { routesAliases } from 'router/routesAliases';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TaskForm from '../Form';

const useStyles = makeStyles(theme => ({
  pageContent: {
    padding: theme.spacing(4, 5),
  },
}));

const Create = ({ routeProps }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const backUrl = routesAliases.jobsTasksList;

  const breadCrumbsItems = [
    {
      title: t(routeProps.parentTitle),
      link: routeProps.parentPath,
    },
    {
      title: t(routeProps.title),
      isActive: true,
    },
  ];

  const goToEdit = jobTaskId => {
    history.push(`${routesAliases.editJobTask}/${jobTaskId}`);
  };

  const [submittingState, sendForm] = useAsyncFn(async formData => {
    const createResult = await createJobTask(formData);

    if (!createResult.error && !createResult.statusCode) {
      goToEdit(createResult.id);
      return createResult;
    }

    return createResult;
  });

  return (
    <PageLayout classes={{ content: classes.pageContent }} pageTitle={<AppBreadcrumbs items={breadCrumbsItems} />}>
      <TaskForm onSubmitForm={sendForm} submitting={submittingState.loading} backUrl={backUrl} />
    </PageLayout>
  );
};

Create.propTypes = {
  routeProps: PropTypes.shape({
    parentPath: PropTypes.string,
    parentTitle: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default Create;
